export const templates = [
  {
    id: "dashboard",
    config: "/dashboard",
    build: () => "/dashboard",
    children: [],
  },
  {
    id: "logoff",
    config: "/logoff",
    build: () => "/logoff",
  },
  {
    id: "search",
    config: "/search/:id",
    build: (id) => `/search/${id}`,
  },
  {
    id: "settings",
    config: "/settings",
    build: () => `/settings`,
  },
  {
    id: "forbidden",
    config: "/403",
    build: () => `/403`,
  },
]
